import React from 'react';
import Icon from './Icon';

const XCircleIcon = (props) => (
    <Icon {...props}>
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 9l6 6M9 15l6-6" strokeLinecap="round" strokeLinejoin="round" />
    </Icon>
);

export default XCircleIcon;